<template>
  <VehicleDetails />
</template>
<script>
import VehicleDetails from '@/components/dashboard/details/VehicleDetails.vue'
export default {
  name: 'VehicleDetailsHost',
  components: {
    VehicleDetails
  }
}
</script>
<style lang="scss" scoped></style>
